import { render, staticRenderFns } from "./MenDianPurchaseSalesJinXiao.vue?vue&type=template&id=2ce29929&scoped=true&"
import script from "./MenDianPurchaseSalesJinXiao.vue?vue&type=script&lang=js&"
export * from "./MenDianPurchaseSalesJinXiao.vue?vue&type=script&lang=js&"
import style0 from "./MenDianPurchaseSalesJinXiao.vue?vue&type=style&index=0&id=2ce29929&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce29929",
  null
  
)

export default component.exports